import React from "react";
import "./style.css";

const Module = ({label, src, highlight="false", onClick}) => {
  return (
    <div className="vertical-nav-button touch-safe" onClick={onClick} highlight={highlight}>
      <a className="label" href={src} draggable={false}>{label}</a>
    </div>
  );
};
export default Module;